import { FC, useState } from 'react'
import { RenderIf } from 'components/RenderIf'

import { ReactComponent as CameraIcon } from 'assets/cameraIcon.svg'

import { ImageContainer, StyledImage } from './styled'
import { useGetTranslatedNames } from 'featureSliced/shared/hooks/useGetTranslatedNames'
import { IProduct } from 'featureSliced/shared/store/reducers/CategoriesReducer/types'

type CartProductType = {
  product?: IProduct
  numberToShow?: number
}

// TODO: rework
export const CartProductImage: FC<CartProductType> = ({
  product,
  numberToShow,
}) => {
  const [isImgErrored, setIsImageErrored] = useState(false)
  const { getProductName } = useGetTranslatedNames()

  return (
    <RenderIf condition={Boolean(product)}>
      <ImageContainer count={numberToShow} isSmall={isImgErrored}>
        {/* <StyledImage
          src={product?.imageUrl || 'ERRORED_IMAGE'}
          // onError={({ currentTarget }) => {
          //   setIsImageErrored(true)
          //   currentTarget.onerror = null // prevents looping
          // }}
          // alt={product?.title
          alt={getProductName(product)}
          width="75"
          height="75"
        /> */}
        <RenderIf condition={!isImgErrored}>
          <StyledImage
            src={product?.imageUrl || 'ERRORED_IMAGE'}
            onError={({ currentTarget, ...rest }: any) => {
              setIsImageErrored(true)
              currentTarget.onerror = null // prevents looping
            }}
            // alt={product?.title}
            alt={getProductName(product)}
            width="75"
            height="75"
          />
        </RenderIf>
        <RenderIf condition={isImgErrored}>
          <CameraIcon />
        </RenderIf>
      </ImageContainer>
    </RenderIf>
  )
}
